// src/app/components/foundation/EmptyState.tsx
import type { ReactNode } from 'react';
import clsx from 'clsx';

export interface EmptyStateProps {
  /** The "nothing here yet" message. */
  message: ReactNode;
  /** Optional leading icon. */
  icon?: ReactNode;
  className?: string;
}

/**
 * Centered placeholder content. Used by every Step 1 route in this app
 * to render a minimal, honest "not built yet" state instead of an empty
 * page. Same contract as representative-admin's EmptyState.
 */
export function EmptyState({ message, icon, className }: EmptyStateProps) {
  return (
    <div className={clsx('flex flex-col items-center gap-3 px-5 py-16 text-center', className)}>
      {icon && <div className="text-[var(--vania-text-tertiary,#6c7280)]">{icon}</div>}
      <p className="text-sm text-[var(--vania-text-secondary,#a6acb8)]">{message}</p>
    </div>
  );
}
